import CoreLabeledTextbox, { Textbox as CoreTextbox } from 'nucleus-core/forms/elements/Textbox';
import wrapInput, { inputOptions } from '../wrapInput';
const textboxOptions = Object.assign(Object.assign({}, inputOptions), { inputIdKey: 'fieldName' });
export const Textbox = wrapInput(textboxOptions)(CoreTextbox);
const labeledTextboxOptions = Object.assign(Object.assign({}, textboxOptions), { defaultIncludeErrorMessages: true });
export default wrapInput(labeledTextboxOptions)(CoreLabeledTextbox);
